import { render, staticRenderFns } from "./TermsMain.vue?vue&type=template&id=24d89d1d&scoped=true&"
import script from "./TermsMain.vue?vue&type=script&lang=js&"
export * from "./TermsMain.vue?vue&type=script&lang=js&"
import style0 from "./TermsMain.vue?vue&type=style&index=0&id=24d89d1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d89d1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d89d1d')) {
      api.createRecord('24d89d1d', component.options)
    } else {
      api.reload('24d89d1d', component.options)
    }
    module.hot.accept("./TermsMain.vue?vue&type=template&id=24d89d1d&scoped=true&", function () {
      api.rerender('24d89d1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Declare/Terms/TermsMain.vue"
export default component.exports